import { Popover as AntdPopover, PopoverProps } from 'antd';
import { PopoverOverlayGlobalStyles } from './PopoverStyles';

export type IPopoverProps = PopoverProps;

const Popover = ({ children, ...props }: IPopoverProps) => (
  <>
    <AntdPopover {...props} overlayClassName="cc-popover-overlay">
      {children}
    </AntdPopover>
    <PopoverOverlayGlobalStyles />
  </>
);

export default Popover;
